import { memo } from 'react';
import { Link, useParams } from 'react-router-dom';
import { PORTAL_ROUTES } from 'utils/constants';
import { timeAgo, getInitials } from 'utils/helpers';

const Item = ({ item }) => {
  const { title, state, encoded_id, last_non_internal_message } = item?.attributes || {}
  const { from_patient, content, time } = last_non_internal_message?.data?.attributes || {}
  const { encodedResourceId } = useParams()
  const isActive = encodedResourceId === encoded_id

  return (
    <Link
      to={`${PORTAL_ROUTES.CONVERSATIONS}/${encoded_id}`}
      className={`relative flex items-start gap-3 px-4 py-3 transition-colors ${
        isActive ? 'bg-blue-50' : 'hover:bg-base-200'
      }`}
    >
      {isActive && (
        <span className="absolute left-0 top-0 bottom-0 w-1 bg-teamcare-blue rounded-r-sm" />
      )}
      <div className="w-7 h-7 my-1 rounded-full bg-teamcare-blue text-white flex items-center justify-center text-sm font-bold shrink-0">
        {getInitials(title)}
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2">
          <span className="text-sm font-semibold text-secondary-800 truncate">{title}</span>
          {time && <span className="shrink-0 text-xs text-secondary-400">{timeAgo(time)}</span>}
        </div>

        <p className="text-xs text-secondary-500 truncate mt-0.5">
          <span className="font-medium text-secondary-900">{from_patient === true ? 'You: ' : ''}</span>
          {content}
        </p>

        <div className="flex items-center gap-1.5 mt-1.5 flex-wrap">
          <span className={`badge badge-sm ${state === 'open' ? 'badge-success' : 'badge-info'} text-white`}>
            {state}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default memo(Item);
